import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// import ListItemText from "@material-ui/core/ListItemText";
import Link from "@material-ui/core/Link";
import ViewTitle from "../../components/ViewTitle";

const styles = theme => ({
  paper: {
    maxWidth: 936,
    margin: 'auto',
    overflow: 'hidden',
  },
  searchBar: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  searchInput: {
    fontSize: theme.typography.fontSize,
  },
  block: {
    display: 'block',
  },
  addUser: {
    marginRight: theme.spacing(1),
  },
  contentWrapper: {
    margin: '40px 16px',
  },
});

function Query(props) {
  const { classes } = props;

  const renderDirections = () => (
    <React.Fragment>
      <ViewTitle>
        Support
      </ViewTitle>
      <Typography variant='h6' component='h6' color="textSecondary" align="center">
        We are happy to assist you!
      </Typography>
      <br/>
      <Typography variant="body1">
        If you need anything, simply email us at
      </Typography>
      <br/>
      <Typography variant="body2" color="textPrimary" align="center">
        <Link href="mailto:support@brandygillmore.com">
          support@brandygillmore.com
        </Link>
      </Typography>
      <br/>
    </React.Fragment>
  );

  return (
    <Paper className={classes.paper}>
      <div className={classes.contentWrapper}>
        {renderDirections()}
      </div>
    </Paper>
  );
}

Query.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Query);
